<template>
  <div class="left_nav">
    <!-- background-color="#545c64"
    active-text-color="#ffd04b"-->
    <el-menu
      :default-active="deActive"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      text-color="#666"
      background-color="#dfe0e1"
      active-text-color="#032e46"
      :unique-opened="uniqueOpened"
    >
      <div v-if="roleCode === '2'">
        <el-submenu :index="n.id" v-for="n in getNavList" :key="n.key">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>{{ n.name }}</span>
          </template>
          <el-menu-item-group v-if="n.hasChild === true">
            <el-menu-item
              v-for="nn in n.childrenList"
              :key="nn.key"
              :index="nn.id"
              @click="changePage(nn)"
            >{{ nn.name }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </div>
      <div v-else>
         <el-submenu :index="n.id" v-for="n in getNavListOther" :key="n.key">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>{{ n.name }}</span>
          </template>
          <el-menu-item-group v-if="n.hasChild === true">
            <el-menu-item
              v-for="nn in n.childrenList"
              :key="nn.key"
              :index="nn.id"
              @click="changePage(nn)"
            >{{ nn.name }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'left_nav',
  data () {
    return {
      deActive: 'Salecharts',
      uniqueOpened: true,
    }
  },
  props: {
    roleCode: String
  },
  methods: {
    handleOpen (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    changePage (n) {
      // console.log(n)
      this.deActive = n.id
      this.$router.push({ path: n.pathId })
    }
  },
  computed: {
    ...mapGetters(['getNavList']),
    ...mapGetters(['getNavListOther'])
  },
  mounted () {
    // console.log(this.getNavList)
    // console.log(this.$router.app._route.name)
    let path = this.$router.app._route.name
    this.deActive = path
    this.$router.push({ path: this.deActive })
  }
}
</script>
<style scoped>
.el-submenu .el-menu-item {
  min-width: 0;
}
.left_nav {
  height: 100%;
}
.el-menu {
  height: 100%;
  min-height: 1280px;
  background-color: #dfe0e1 !important;
}
</style>
